// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { Injectable } from '@angular/core';
import { StatePersister } from '../../services/state-persister';
import * as fromSettings from '../settings/settings.reducer';

@Injectable({
  providedIn: 'root'
})
export class SettingsPersisterService extends StatePersister<fromSettings.State> {
  constructor() {
    super(sessionStorage, fromSettings.featureKey);
  }
}
